module.exports = __webpack_public_path__ + "app/images/header/synergist-computing-emblem-300_Adobe Sign logo.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/header/synergist-computing-emblem-300_Adobe Sign logo.png
// module id = 462
// module chunks = 0